<template>
    <v-ons-page>
        <TopBar back="true"></TopBar>
        <div class="centerAll">
            <p>
                {{ $t("message.download") }}
            </p>
            <v-ons-progress-bar class="bar" :value="status"></v-ons-progress-bar>

            <p style="    font-size: xx-large;">
                {{ status}}%
            </p>
            <p v-if="retry">
                <v-ons-button modifier="outline" @click="download()" class="black">
                    {{ $t("message.retry") }}
                </v-ons-button>

            </p>
        </div>
        <BottomBar></BottomBar>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import MenuPage from './MenuPage'
    import BottomBar from '../components/BottomBar'
    import constatns from '../constants'
    import Image from "./ImagePage"
    //    import ContentSync from '../sync'
    import axios from 'axios'


    export default {
        name: 'loading',
        components: {
            Image,
            TopBar,
            BottomBar
        },
        data: function () {
            return {
                status: 0,
                retry: false
            }
        },
        methods: {
            push() {
                this.$emit('push', {
                    extends: MenuPage,

                });
            },
            replace() {
                this.$emit('replace', MenuPage);
            },
            download() {
                this.retry = false;
                let sync = ContentSync.sync({
                    src: constatns.URL_AUDIO + this.$i18n.locale.replace(new RegExp(/ñ/g),"n").replace(new RegExp(/ç/g),"c") + '.zip',
                    id: 'audio_' + this.$i18n.locale

                });
                sync.on('progress', data => {
                    this.status = data.progress;
                });

                sync.on('complete', data => {

                    axios.get(constatns.URL_AUDIO + '/?file=' + this.$i18n.locale)
                        .then(response => {
                            // handle success
                            let storage = window.localStorage;
                            storage.setItem('audio_date_' + this.$i18n.locale, response.data);
                            this.replace();

                        })
                });

                sync.on('error', (e) => {
                    alert(this.$t("message.errorDownload"));
                    this.retry = true;
                });

                sync.on('cancel', () => {
                    alert(this.$t("message.cancelDownload"));
                    console.log("triggered if event is cancelled")
                })
                ;
            }
        },
        mounted() {
            if (this.$store.state.connection.connected) {
                this.download();
            } else {
                this.$emit('pop');
                alert(this.$t("message.noConnection"))
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .centerAll {
        height: 30%;
        text-align: center;
        margin-top: 30%;

    }

    .black {
        margin: 6px 0;
        color: black;
        border-color: black
    }

    .bar {
        margin: 10% 20%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/LoadingPage.vue